import React, { useEffect } from 'react';
import { Button, Input, Modal } from '../../../../../../common/components';
import styled from "styled-components";
import { GhostButton } from '../../../../../../common/components/GhostButton';
import { Row } from '../../common';

interface Props {
    isOpen: boolean;
    instagram: string;
    onSubmit: (value: string) => any;
    onCancel: () => any;
}

export const InstagramModal: React.FC<Props> = (props: Props) => {
    const { isOpen, instagram } = props;
    const [value, setValue] = React.useState(instagram);

    const onSubmit = () => {
        props.onSubmit(value);
    }

    const onCancel = () => {
        setValue(instagram);
        props.onCancel();
    }

    useEffect(() => {
        setValue(instagram);
    }, [instagram])

    return (
        <Modal isOpen={isOpen}>
            <Row>
                <label htmlFor="instagram-input">Your instagram account</label>
                <Input
                    id="instagram-input"
                    value={value}
                    onChange={setValue}
                    placeholder="Example: @charlie"
                />
            </Row>
            <Actions>
                <GhostButton onClick={onCancel}>Cancel</GhostButton>
                <Button onClick={onSubmit}>Save</Button>
            </Actions>
        </Modal>
    );
}

const Actions = styled.div`
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
`;
